import { Typography } from '@mui/material';
import { Alert } from '@side/pantry';
import { useEffectOnce } from 'react-use';
import { useClearPageBannerById } from '@/state/navigation';
import { ACTIVE_SIDE_LISTINGS_ONLY_STATES } from '@/views/Community/constants';
import { TrackCommunityEvent } from '$analytics/useTrackAnalytics/domains/community/events';
import { useTrackCommunityAnalytics } from '$analytics/useTrackAnalytics/domains/community/useTrackCommunityAnalytics';
import { useAppFlags } from '$launch-darkly/app-flags';

export const StatusChangeBannerId = 'TRANSACTION_STATUS_CHANGED';

interface Props {
  interactionId: string;
  interactionStatus?: string;
  market: string;
}

const DEFAULT_TEXT =
  'Only Off Market, Coming Soon, Active, Active Contingent, and On Market transactions can be displayed on';
const RESTRICTED_STATES_TEXT =
  'Only Active, Active Contingent, and On Market transactions can be displayed on';

export const StatusChangedBanner = ({
  interactionId,
  interactionStatus,
  market,
}: Props) => {
  const clearPageBanner = useClearPageBannerById(interactionId);
  const trackEvent = useTrackCommunityAnalytics();
  const { txmSideListingsRename } = useAppFlags();
  const feedName = txmSideListingsRename ? 'the Listing Feed' : 'Side Listings';

  const handleClose = () => {
    clearPageBanner(StatusChangeBannerId);
    trackEvent(TrackCommunityEvent.StatusChangedBannerClose);
  };

  useEffectOnce(() => {
    trackEvent(TrackCommunityEvent.StatusChangedBannerView, {
      interactionStatus,
    });
  });

  const isRestrictedMarket = ACTIVE_SIDE_LISTINGS_ONLY_STATES.has(market);

  return (
    <Alert
      severity="primary"
      square
      aria-label="Tranaction Status Changed"
      onClose={handleClose}
    >
      <Typography>Status Changed: Hidden from {feedName}</Typography>
      {`${isRestrictedMarket ? RESTRICTED_STATES_TEXT : DEFAULT_TEXT} ${feedName}`}
    </Alert>
  );
};
